import PaymentClientService from "entities/payment-client-service";
import PaymentHeader, { PaymentHeaderTypes } from "entities/payment-header";
import {
  paymentTypesBankTransfer,
  paymentTypesRemaining,
} from "shared/utils/payment";
import PaymentMethods, { PaymentMethod } from "widgets/shared/payment-methods";
import { OrderType, usePaymentContext } from "../providers/PaymentProvider";

export default function ZakelijkPaymentDetails() {
  const { paymentAction, getPaymentListWithAssembly, setPaymentAction } =
    usePaymentContext();

  const paymentTypes = getPaymentListWithAssembly([
    ...paymentTypesRemaining,
    ...paymentTypesBankTransfer,
  ]);
  return (
    <div
      className={`gg-col-span-12 gg-mb-16 sm:gg-col-span-11 lg:gg-col-span-9 xl:gg-col-span-6 xl:gg-mb-0 xl:gg-pr-12`}
    >
      <PaymentHeader
        type={PaymentHeaderTypes.ALL_PAYMENTS}
        className="gg-mb-10"
      />

      <PaymentMethods
        method={PaymentMethod.DEFERRED_PAYMENT}
        types={paymentTypes}
        paymentAction={paymentAction}
        setPaymentAction={setPaymentAction}
        orderType={OrderType.DOOR}
        isSampleSale={false}
      />
      <PaymentClientService />
    </div>
  );
}
